<template>
	<div class="form-group select_items_filter_wrapper" :class="moreClass">
		<label class="label d-block">{{ FormMSG(1, 'Purchase order') }}</label>
		<div class="custom-tag-select">
			<div class="tags" v-if="selectedPoData && selectedPoData.length > 0">
				<div v-for="(po, index) in selectedPoData" :key="index" class="tag">
					<div class="pr-1" style="margin: 1px 0 0 0; font-weight: 500">{{ po.id }}</div>
					<button @click.stop="openPoDocumentInNewWindow(po)">
						<component :is="getLucideIcon('File')" :size="18" color="#59c1bf" :stroke-width="1.5" />
					</button>
					<button :disabled="isDisabled" @click.stop="removeSelectedPo(po.id, index)">
						<component :is="getLucideIcon('X')" color="#3D3B8FAB" :size="18" :stroke-width="3" />
					</button>
				</div>
			</div>
			<div class="tags" v-else>
				<span class="px-2 m-0 py-1 text-muted small">{{ FormMSG(3, 'No PO') }}</span>
			</div>
			<button
				class="add-btn"
				:disabled="isDisabled"
				@click="$emit('click:more')"
				:class="({ 'cursor-not-allowed': isDisabled }, { 'cursor-pointer': !isDisabled })"
			>
				<component :is="getLucideIcon('PlusCircle')" color="#00A09C" :size="18" :stroke-width="2.25" />
			</button>
		</div>
		<slot name="error"></slot>
	</div>
</template>

<script>
// mixin
import globalMixin from '@/mixins/global.mixin';
import languageMessages from '@/mixins/languageMessages';
import invoicesToolsMixin from '@/mixins/invoicesTools.mixin';
// utils
import _ from 'lodash';
// constants
import { INVOICE_ATTACHEMENTS_TYPE } from '@/shared/constants';

export default {
	name: 'PoSelector',
	mixins: [languageMessages, globalMixin, invoicesToolsMixin],
	props: {
		moreClass: {
			type: String,
			default: ''
		},
		selectedPoData: {
			type: Array,
			default: () => []
		},
		isDisabled: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		removeSelectedPo(poID, index) {
			const copyData = _.cloneDeep(this.selectedPoData);
			copyData.splice(index, 1);
			this.$emit('change:poList', poID, copyData);
		},
		openPoDocumentInNewWindow(po) {
			if (po.documents && po.documents.length > 0) {
				const viewerUrl = `${process.env.BASE_URL}/#/invoice-files-viewer/${INVOICE_ATTACHEMENTS_TYPE.PO}/${po.id}?doc=${po.documents[0].xid}.${po.documents[0].ext}&label=${po.documents[0].originalFileName}`;
				this.openNewWindowTab(viewerUrl);
			} else {
				this.createToastForMobile(this.FormMSG(4, 'Info'), this.FormMSG(5, 'This purchase order has no document attached'), '', 'info');
			}
		}
	}
};
</script>

<style scoped>
.custom-tag-select {
	display: flex;
	align-items: center;
	justify-content: space-between;
	border: 1px solid #ccc;
	padding: 2px;
	border-radius: 8px;
}

.tags {
	display: flex;
	flex-wrap: wrap;
}

.tag {
	background-color: #f3f3f3;
	border: 1px solid #ccc;
	border-radius: 4px;
	padding: 2px 4px;
	margin-right: 4px;
	display: flex;
	align-items: center;
	gap: 8px;
}

.tag button {
	background: none;
	border: none;
	padding: 0;
}

.tag-input {
	border: none;
	outline: none;
	flex: 1;
	min-width: 100px;
}

.add-btn {
	background-color: white;
	color: white;
	border: none;
	padding: 0 5px;
	margin-left: 10px;
}

.cursor-pointer {
	cursor: pointer;
}

.cursor-not-allowed {
	cursor: not-allowed;
}
</style>
